import React from 'react';

import Select from 'react-select';

import registerType from '@/data/registerType';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectRegisterType: React.FC<any> = ({ name, value, defaultValue, placeholder, handleChange, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={registerType.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={registerType}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectRegisterType;
